import {typographyStyles, constants, mediaQueryStyles} from '@newsela/angelou';
import {css} from 'emotion';
const {mediaQuery} = mediaQueryStyles;
const {breakpoints} = constants;

const {
  textXSObj: text4Obj, heading5Obj
} = typographyStyles;

const {ui} = constants.colors;

export const headerContainerStyle = (isFreeUser) => css({
  backgroundColor: isFreeUser ? ui.greyDark[700] : ui.coreBlue[500],
  display: 'flow-root',
  color: ui.white[50],
});

export const buttonWithPopOutStyle = {
  buttonContents: {
    maxHeight: '50px',
    svg: {
      height: 'unset'
    }
  },
  PopOut: {
    root: {
      zIndex: '1',
      right: '17rem',
      [mediaQuery.upTo(breakpoints.BreakpointNames.xs)]: {
        left: '-11rem'
      },
    },
    popOutContents: {
      maxWidth: '350px',
      overflow: 'auto',
      [mediaQuery.upTo(breakpoints.BreakpointNames.xs)]: {
        maxWidth: '250px'
      },
    }
  }
};

export const navMenuListStyles = css({
  width: '350px',
  padding: 0,
  [mediaQuery.upTo(breakpoints.BreakpointNames.xs)]: {
    width: '250px'
  },
});

export const userSectionStyle = css({
  display: 'grid',
  gridTemplateAreas: `"avatar name"
                      "avatar email"`,
  gridTemplateColumns: 'auto 1fr',
  gridGap: '7px',
  gridTemplateRows: 'auto auto',
  padding: '8px 24px',
  margin: '8px 0',
});

export const avatarArea = css({
  gridArea: 'avatar',
  display: 'flex',
  alignItems: 'center',
});

export const avatarIconStyle = css({
  color: ui.white[50],
  borderColor: ui.white[50],
});

export const userNameArea = css({
  gridArea: 'name',
  wordBreak: 'break-word',
  ...heading5Obj
});

export const emailArea = css({
  gridArea: 'email',
  wordBreak: 'break-word',
  color: ui.grey[500],
  ...text4Obj
});

export const licenseEmailArea = css({
  color: ui.greyLight[100],
});

export const iconStyle = css({
  width: '16px',
  length: '16px',
  margin: '0px 8px 0px 0px'

});
